import { GridRowSelectionModel } from "@mui/x-data-grid";
import { OrderRowType } from "./OrderData";
import { Link, useLocation } from "react-router-dom";
import { Checkbox, Chip, Pagination, Stack, Typography } from "@mui/material";
import { Card } from "../../ui/Card";
import { EditButton } from "./EditButton";
import { CurrencyRupee, LocalShipping } from "@mui/icons-material";

export const DataTableForMobile = ({
  rows,
  setSelectedId,
  selectedId,
  checkBox,
  totalRow,
  page,
  updatePage,
}: {
  totalRow?: number;
  page?: number;
  updatePage?: (e: React.ChangeEvent<unknown>, page: number) => void;
  checkBox: boolean;
  rows: OrderRowType[];
  selectedId: number[] | GridRowSelectionModel;
  setSelectedId: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>;
}) => {
  const location = useLocation();

  const handleSelectionOrder = (id: number) => {
    if (selectedId.includes(id)) {
      const newSelectedId = [...selectedId];
      newSelectedId.splice(newSelectedId.indexOf(id), 1);
      setSelectedId(newSelectedId);
    } else {
      setSelectedId([...selectedId, id]);
    }
  };

  return (
    <Stack gap={"10px"}>
      {rows &&
        rows.map((row, index) => (
          <div key={index}>
            <Card
              style={{
                padding: "10px",
              }}
            >
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{
                  borderBottom: "0.1px solid #1515154e",
                  marginY: "10px",
                  paddingRight: "10px",
                }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {checkBox && (
                    <Checkbox
                      checked={selectedId.includes(row.id) ? true : false}
                      size="small"
                      onClick={() => handleSelectionOrder(row?.id)}
                    />
                  )}
                  <Link
                    to={`/order/details/${row?.id}`}
                    state={{ prevurl: location.pathname + location.search }}
                  >
                    <Typography fontWeight={600} color={"#004982"}>
                      {row?.id}
                    </Typography>
                  </Link>
                </Stack>
                <div
                  style={{
                    marginBottom: "10px",
                  }}
                >
                  <EditButton
                    showBook={"vertical"}
                    id={row?.id}
                    status={row?.status}
                    vendor={row?.vendor}
                  />
                </div>
              </Stack>
              <div>
                <Stack
                  gap={"10px"}
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                >
                  {row?.status !== "ready_to_ship" && (
                    <Stack
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"center"}
                    >
                      <Typography fontSize={"12px"}>Awb</Typography>
                      <Typography fontSize={"14px"}>: {row?.awb}</Typography>
                    </Stack>
                  )}
                  <Stack
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                  >
                    <Typography fontSize={"12px"}>Receiver</Typography>
                    <Typography fontSize={"14px"}>: {row?.receiver}</Typography>
                  </Stack>

                  <Stack
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                  >
                    <LocalShipping
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                    <Typography fontSize={"14px"}>: {row?.vendor}</Typography>
                  </Stack>
                  <Stack
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                  >
                    <CurrencyRupee
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                    <Typography fontSize={"14px"}>
                      : Rs {row?.amount ?? 0}
                    </Typography>
                  </Stack>
                  <Stack
                    width={"100%"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    paddingRight={"10px"}
                  >
                    <Chip
                      sx={{
                        padding: "1px 1px",
                      }}
                      label={row?.status}
                      variant="outlined"
                      color="success"
                    />

                    <EditButton
                      showBook={"book"}
                      id={row?.id}
                      status={row?.status}
                      vendor={row?.vendor}
                    />
                  </Stack>
                </Stack>
              </div>
            </Card>
          </div>
        ))}
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"flex-end"}
        marginTop={"20px"}
      >
        <Pagination count={totalRow} page={page} onChange={updatePage} />
      </Stack>
    </Stack>
  );
};
